// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Organism_Carousel from "./Organism_Carousel.bs.js";
import * as Molecule_TopTeaser_Presse from "../../molecule/Molecule_TopTeaser_Presse.bs.js";

function Organism_Carousel_Presse(Props) {
  var id = Props.id;
  var label = Props.label;
  var content = Props.content;
  return React.createElement(Organism_Carousel.make, {
              id: id,
              children: Belt_Array.map(content, (function (param) {
                      return React.createElement(Molecule_TopTeaser_Presse.make, {
                                  title: param.title,
                                  subtitle: param.subtitle,
                                  description: param.description,
                                  href: param.href,
                                  imageAlt: param.imageAlt,
                                  imageSrc: param.imageSrc
                                });
                    })),
              kind: Organism_Carousel.Organism_Carousel_Ds.presse,
              label: label
            });
}

var make = Organism_Carousel_Presse;

export {
  make ,
}
/* react Not a pure module */
